import { render, staticRenderFns } from "./MaskedLink.vue?vue&type=template&id=4b4b8e00&scoped=true"
import script from "./MaskedLink.vue?vue&type=script&lang=js"
export * from "./MaskedLink.vue?vue&type=script&lang=js"
import style0 from "./MaskedLink.vue?vue&type=style&index=0&id=4b4b8e00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4b8e00",
  null
  
)

export default component.exports